import React, { useState, createContext } from "react"
import Link from "~components/link/link"
import * as styles from "./scrolling-tooltips.module.css"

export const TooltipContext = createContext(() => {})

export const ScrollingTooltips = (props) => {
  const [currentTooltip, setCurrentTooltip] = useState()

  return (
    <TooltipContext.Provider value={setCurrentTooltip}>
      {currentTooltip && <Tooltip {...currentTooltip} />}
      {props.children}
    </TooltipContext.Provider>
  )
}

const Tooltip = ({ position, title, link }) => {
  const tooltipStyle = {
    top: position.top + "px",
    left: position.left + "px",
  }
  return (
    <Link className={styles.tooltip} to={link} style={tooltipStyle}>
      {title}
    </Link>
  )
}
